<template>
  <section>
    <ResourcesNcfHeader />
    <ResourcesNcfIntro />
    <ResourcesNcfContent />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ResourcesNcf',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['resources-ncf'] || {}
    }
  },
  mounted() {
    console.log('NCF', this.$wp.pages['resources-ncf'])
  }
}
</script>
